import { Heading03 } from 'module/ui/components/styles';
import styled from 'styled-components';
import { CollapsibleItem, Item } from './item';

const BlockListElement = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
`;
const Header = styled.div`
  ${Heading03};
`;

type BlockList = typeof BlockListElement & {
  Header: typeof Header;
  Item: typeof Item;
  CollapsibleItem: typeof CollapsibleItem;
};
export const BlockList: BlockList = BlockListElement as any;
BlockList.Header = Header;
BlockList.Item = Item;
BlockList.CollapsibleItem = CollapsibleItem;
